import React from 'react';

import SelectClassSizeScreen from 'screens/settings/screens/MyClassScreen/SelectClassSizeScreen';

export default (props: any) => <SelectClassSizeScreen {...props} onboarding={true} />;
